export const WORKER_URL = 'https://integra-mkt-api.bot-mercadoflow.workers.dev';

export const getAuthHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('saas_token')}`,
});
